export {
  DSTooltipV3,
  DSTooltipV3WithSchema,
  TOOLTIP_V3_DATA_TESTID,
  TOOLTIP_V3_SLOTS,
  TooltipV3DatatestId, // legacy way to share the datatestid for v3, kept for backward compatibility
  type DSTooltipV3T,
} from '@elliemae/ds-tooltip-v3';
export * from './v1/DSTooltip.js';
export * from './v2/DSTooltip.js';
export * from './v2/TooltipType.js';
export { tooltipPositions } from './v2/utils/tooltipPositions.js';
